<!--
****** NOTES: ******
- change prop VALUE to LABEL... (better naming for something display only)
- change prop NAME to VALUE... (better naming for something that is emmited on click)
- is click disabled and disabled both necessary?
- keyboard navigation (using span as a wrapper... use a button and reset it. default behaviour for keyboard nav)
-->

<!-- eslint-disable vue-a11y/click-events-have-key-events -->
<template>
	<span
		class="c-Chip"
		:class="chipClassObject"
		@click="emitClick">
		<!-- @slot Use this slot for Chip leading content -->
		<slot name="leading"></slot>
		<span class="c-Chip__value">{{ value }}</span>
	</span>
</template>

<script>
export default {
	name: 'Chip',
	props: {
		/**
     * The Chip label
     */
		value:{
			type: [Number, String],
			required: true,
			default: () => '',
		},
		/**
     * The Chip value to be emmited on click
     */
		name:{
			type: String,
			required: false,
			default: () => '',
		},
		/**
     * The Chip active state
     * @values true, false
     */
		active: {
			type: Boolean,
			required: false,
			default: () => false,
		},
		/**
     * If the Chip is disabled
     * @values true, false
     */
		disabled: {
			type: Boolean,
			required: false,
			default: () => false,
		},
		/**
     * If the Chip is click is disabled
     * @values true, false
     */
		clickDisabled: {
			type: Boolean,
			required: false,
			default: () => false,
		},
		/**
     * If the Chip should be in Dark Mode
     * @values true, false
     */
		isDark: {
			type: Boolean,
			required: false,
			default: () => false,
		}
	},
	computed: {
		chipClassObject() {
			return {
				'is-active': this.active,
				'is-disabled': this.disabled,
				'is-click-disabled': this.clickDisabled,
				'is-dark': this.isDark,
			};
		},
	},
	methods: {
		emitClick() {
			if (!(this.disabled || this.clickDisabled)) {
				/**
         * Triggers when Chip is clicked
         * @event click
         * @property {string} name value to be emmited
         */
				this.$emit('click', this.name)
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../../scss/variables.scss';

.c-Chip {
  $fontsize-button: 14px;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid $un-n600;
  border-radius: calc(#{$border-radius} * 4);
  padding: calc((#{$base-padding} / 2) - 1px) calc(#{$base-padding} / 2);
  background-color: transparent;
  cursor: pointer;

  &__value {
    color: $un-n600;
    font-family: $primary-font;
    font-weight: 400;
    font-size: $fontsize-button;
    letter-spacing: 0.25px;
    text-decoration: none;
    /* text unselectable */
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  &.is-active {
    border-color: $un-blue;
    background-color: $un-blue;
    .c-Chip__value {
      color: $un-white;
    }
  }
  &.is-disabled {
    border-color: $un-n200;
    background-color: $un-n200;
    cursor: not-allowed;

    .c-Chip__value {
      color: $un-n400;
    }
  }

  &.is-click-disabled{
    cursor: default;
  }

  &.is-dark {
    border-color: $un-lilac-darker;
    background-color: $un-lilac-darker;

    .c-Chip__value {
      color: $un-white;
    }

    &.is-active {
      border-color: $un-lilac-dark;
      background-color: $un-lilac-dark;
    }
    &.is-disabled {
      border-color: $un-n900;
      background-color: $un-gray-bg;
      cursor: not-allowed;

      .c-Chip__value {
        color: $un-n900;
      }
    }
  }
}
</style>
